import { Expose } from 'class-transformer';
import * as uuid from 'uuid';

import { SnModel } from '@lib/common/models';

export class FsEvidenceIqCatridgeCase extends SnModel {
  public id: string = uuid.v4();

  @Expose({ name: 'Agency' })
  public agency: string;

  @Expose({ name: 'CartridgeCases' })
  public cartridgeCases: any[];

  @Expose({ name: 'CaseIncident' })
  public caseIncident: string;

  @Expose({ name: 'Locations' })
  public locations: any[];

  @Expose({ name: 'NumberOfCartridgeCasesScaned' })
  public numberOfCartridgeCasesScaned: string;

  @Expose({ name: 'Url' })
  public url: string;

  @Expose({ name: 'CaseNotes' })
  public caseNotes: string;

  @Expose({ name: 'CartridgeCaseNumber' })
  public cartridgeCaseNumber: string;

  @Expose({ name: 'DateOfIncident' })
  public dateOfIncident: string;

  @Expose({ name: 'ImageUrls' })
  public imageUrls: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
